<template>
  <div id="app" :class="'page-' + $t.lang">
    <myheader class="header" :showUser="false"></myheader>
    <div id="login-box">
      <img
        :src="$t('login_image_guide')"
        class="guide-image"
        :class="loginType == 'qrcode' ? 'show-guide' : 'hide-guide'"
      />
      <div class="login-top">
        <div
          class="login-toggle-btn"
          :class="loginType == 'qrcode' ? 'active' : ''"
          @click="changeLoginType('qrcode')"
        >
          {{ $t('QRcode login') }}
        </div>
        <div
          class="login-toggle-btn"
          :class="loginType == 'user' ? 'active' : ''"
          @click="changeLoginType('user')"
        >
          {{ $t('Account login') }}
        </div>
      </div>
      <div v-show="loginType == 'qrcode'" class="qrcode-login">
        <div class="qrcode-img-w">
          <img v-show="loadedQrcode" :src="qrcode" class="qrcode-img" />
        </div>
        <div class="alt-word">
          {{ $t('open Elfinbook APP and click the scan login in sidebar') }}
        </div>
        <div style="text-align: center">
          <div v-show="codeOutdate" class="codeOutdate" @click="reload">
            {{ $t('Invalid qrcode, please refresh website') }}
          </div>
        </div>
      </div>
      <div v-show="loginType == 'user'" class="user-login">
        <div class="input-line">
          <div class="input-name"></div>
          <input
            v-model="inputName"
            type="text"
            class="input"
            maxlength="40"
            :placeholder="$t('Enter your phone number or email address')"
          />
        </div>
        <div class="input-line">
          <div class="input-pass"></div>
          <input
            v-model="inputPass"
            type="password"
            class="input"
            maxlength="40"
            :placeholder="$t('Enter your password')"
            @keydown.enter="submit"
          />
        </div>
        <div
          class="submit"
          :class="canSubmit && !ajaxLock ? '' : 'disable-submit'"
          @click="submit"
        >
          {{ !ajaxLock ? $t('Login') : $t('Logining') }}
        </div>
        <div
          class="auto-login"
          :class="is_remember ? 'is_remember' : 'no_remember'"
          @click="is_remember = !is_remember"
        >
          {{ $t('remember password') }}
        </div>
      </div>
    </div>
    <myfooter class="footer"></myfooter>
  </div>
</template>

<script>
const md5 = require('blueimp-md5');
import Ajax from '../../utils/Ajax';
import myfooter from '../../components/my-footer.vue';
import myheader from '../../components/my-header.vue';
import { Message } from 'element-ui';
const qs = require('querystringify');
let redirect_url = decodeURIComponent(
  qs.parse(location.search).redirect_url || ''
);

import loadTalkData from '@u/loadTalkData';
import report from '@u/report';

window._report = report;
// 加载统计代码
loadTalkData();

function checkString(val) {
  val = val || '';
  return val.trim();
}

export default {
  components: {
    myfooter,
    myheader
  },
  data() {
    return {
      loginType: 'qrcode',
      inputName: '',
      inputPass: '',
      is_remember: false,
      timer: '',
      stopTimer: false,
      qrcode: '',
      ajaxLock: false,
      loadedQrcode: false,
      codeOutdate: false
    };
  },
  computed: {
    canSubmit() {
      if (checkString(this.inputName) && checkString(this.inputPass)) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    qrcode(val) {
      let image = new Image();
      image.onload = () => {
        this.loadedQrcode = true;
      };
      image.onerror = () => {
        this.loadedQrcode = true;
      };
      image.src = val;
    }
  },
  created() {
    if (localStorage.getItem('remember')) {
      this.inputName = localStorage.getItem('username') || '';
      this.inputPass = localStorage.getItem('password') || '';
    }
  },
  mounted() {
    this.getQrcode().then(() => {
      this.timer = this.checkScanQrcode();
    });
  },
  methods: {
    reload() {
      window.location.reload();
    },
    getQrcode() {
      return Ajax.get('/site/qrcode', {
        params: {
          sceneId: 1,
          sceneStr: '1/1'
        }
      }).then((d) => {
        if (d.code == 0) {
          this.ticketId = d.data.ticketId;
          this.loadedQrcode = false;
          this.qrcode = d.data.qrCodeUrl;
        }
      });
    },
    checkScanQrcode() {
      let count = 0;
      let timer = setInterval(() => {
        if (this.stopTimer) {
          return;
        }
        count++;
        if (count > 40) {
          Message({
            message: this.$t('Invalid qrcode, please refresh website'),
            type: 'error'
          });
          this.codeOutdate = true;
          this.stopTimer = true;
          return;
        }
        Ajax.post('/site/loginByScan', { ticketId: this.ticketId }).then(
          (data) => {
            if (data.code == 0) {
              window._report(`(登录)二维码登录成功`);
              localStorage.setItem('islogin', 1);
              sessionStorage.setItem('isLogin', 1);
              localStorage.setItem('userinfo', JSON.stringify(data.data));
              let url = sessionStorage.getItem('loginRedirectUrl');
              if (url && !/login/.test(url)) {
                location.href = url;
              } else {
                location.href = './doc';
              }
            } else if (data.code == 1002) {
              Message({
                message: this.$t('Invalid qrcode, please refresh website'),
                type: 'error'
              });
              this.codeOutdate = true;
              this.stopTimer = true;
            } else if (data.code != 1001) {
              this.stopTimer = true;
              Message({
                message:
                  this.$t('Server Error') + ',' + this.$t('try again later'),
                type: 'error'
              });
            }
          }
        );
      }, 3000);
      return timer;
    },
    changeLoginType(type) {
      if (type == 'user') {
        this.stopTimer = true;
      } else {
        this.stopTimer = false;
      }
      this.loginType = type;
    },
    submit() {
      if (!checkString(this.inputName)) {
        Message({
          title: this.$t('message'),
          message: this.$t('phone number or e-mail must not be empty'),
          duration: 4000,
          type: 'error'
        });
        return;
      }
      if (!checkString(this.inputPass)) {
        Message({
          title: this.$t('message'),
          message: this.$t('password must not be empty'),
          duration: 4000,
          type: 'error'
        });
        return;
      }
      if (this.ajaxLock) {
        return;
      }
      this.ajaxLock = true;
      Ajax.post('/site/login', {
        uname: this.inputName,
        hash: md5(this.inputPass),
        rememberMe: this.is_remember ? 1 : 0
      })
        .then(
          (data) => {
            window._report(`(登录)账号登录成功`);
            if (data.code == 0) {
              localStorage.setItem('islogin', 1);
              sessionStorage.setItem('isLogin', 1);
              localStorage.setItem('userinfo', JSON.stringify(data.data));
              if (this.is_remember) {
                localStorage.setItem('remember', 1);
                // localStorage.setItem('username', this.inputName);
                // localStorage.setItem('password', this.inputPass);
              }
              let url = sessionStorage.getItem('loginRedirectUrl');
              if (redirect_url && !/login/.test(redirect_url)) {
                location.href = redirect_url;
                return;
              } else if (url && !/login/.test(url)) {
                location.href = url;
              } else {
                if (location.href.indexOf('/cn/') > -1) {
                  location.href = '/cn/doc';
                } else {
                  location.href = '/en/doc';
                }
              }
            } else if (data.code == 1000) {
              Message({
                title: this.$t('message'),
                message: data.data,
                duration: 4000,
                type: 'error'
              });
            } else {
              Message({
                title: this.$t('message'),
                message: this.$t('Server Error') + ':' + data.code,
                duration: 4000,
                type: 'error'
              });
            }
          },
          () => {}
        )
        .then(() => {
          this.ajaxLock = false;
        });
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/mixin.scss';

body {
  background: #f4f4f4;
  min-width: 1080px;
}
#app {
  position: relative;
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
}

#login-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 436px;
  height: 461px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.login-top {
  overflow: hidden;
  line-height: 48px;
  text-align: center;
}

.login-toggle-btn {
  font-weight: bold;
  cursor: pointer;
  float: left;
  width: 50%;
  font-size: 16px;
  background: rgba(249, 249, 249, 1);

  &.active {
    color: $green;
    background: #fff;
  }
}

.qrcode-login {
  overflow: hidden;
}

.qrcode-img-w {
  margin: 75px auto 21px;
  display: block;
  width: 170px;
  height: 170px;
}

.qrcode-img {
  width: 100%;
  height: 100%;
  display: block;
}

.alt-word {
  text-align: center;
}

.codeOutdate {
  cursor: pointer;
  display: inline-block;
  margin-top: 45px;
  color: #f66940;
  font-size: 16px;
  padding-right: 19px;
  @include bg('login_icon_refresh', right center, 16px 16px);
}

.user-login {
  overflow: hidden;
  padding: 66px 32px 0;
}

.input-line {
  position: relative;
  height: 44px;
  background: rgba(250, 250, 250, 1);
  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  border: 1px solid rgba(216, 216, 216, 1);
  line-height: 44px;
  margin-bottom: 32px;

  .input {
    padding-left: 56px;
    height: 44px;
    width: 100%;
    background: #fafafa;
  }
}

.input-name {
  position: absolute;
  width: 56px;
  height: 44px;
  left: 0;
  top: 0;
  @include bg('login_icon_account', 15px center, 24px 24px);
}

.input-pass {
  position: absolute;
  width: 56px;
  height: 44px;
  left: 0;
  top: 0;
  @include bg('login_icon_password', 15px center, 24px 24px);
}

.submit {
  text-align: center;
  height: 44px;
  line-height: 44px;
  background: rgba(13, 203, 184, 1);
  border-radius: 2px;
  font-size: 18px;
  color: #fff;
  margin-bottom: 22px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.disable-submit {
  opacity: 0.4;
  cursor: not-allowed;
}

.auto-login {
  float: left;
  cursor: pointer;
  color: #666;
  padding-left: 21px;
}

.register-btn {
  float: right;
  color: #0dcbb8;
}

.is_remember {
  @include bg('login_icon_selected', 0 center, 14px 14px);
}

.no_remember {
  @include bg('login_icon_automatic', 0 center, 14px 14px);
}

.guide-image {
  position: absolute;
  right: -290px;
  top: 10px;
  width: 255px;
  height: 429px;
  transition: all 0.5s;
  opacity: 0.3;
  transform: translateX(-40px);
}

.show-guide {
  opacity: 1;
  transform: translateX(0px);
}

.hide-guide {
  opacity: 0;
  transform: translateX(-40px);
}
</style>
